import { useParams, Navigate } from "react-router-dom";
import GenericModulePage from "@/components/GenericModulePage";
import { MODULES_REGISTRY } from "@/pages/modules/registry";
import InterventionReportModule from "@/pages/modules/InterventionReportModule";
import CheckupModule from "@/pages/modules/CheckupModule";
import MinutePackageReportModule from "@/pages/modules/MinutePackageReportModule";

const CUSTOM_COMPONENTS = {
  "intervention-report": InterventionReportModule,
  "checkup": CheckupModule,
  "minute-package-report": MinutePackageReportModule,
};

export default function ModuleRunner() {
  const { moduleId } = useParams();
  const mod = MODULES_REGISTRY.find((m) => m.id === moduleId);
  if (!mod) return <Navigate to="/moduli" replace />;

  if (mod.custom) {
    const Comp = CUSTOM_COMPONENTS[mod.id];
    if (!Comp) return <Navigate to="/moduli" replace />;
    return <Comp meta={mod} />;
  }

  return (
    <GenericModulePage
      moduleId={mod.id}
      title={mod.title}
      subtitle={mod.subtitle}
      icon={mod.icon}
      endpoint={mod.endpoint}
      filenamePrefix={mod.filenamePrefix}
      fields={mod.fields}
      defaults={mod.defaults}
      emailSubjectBuilder={mod.emailSubject}
      emailBodyBuilder={mod.emailBody}
    />
  );
}
